import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { CorporateAddComponent } from '../corporate-add/corporate-add.component';
@Component({
  selector: 'app-corporate-list',
  templateUrl: './corporate-list.component.html',
  styleUrls: ['./corporate-list.component.css'],
})
export class CorporateListComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'title',
    'menuOrder',
    'showInMenu',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  private listApi = environment.url + environment.initiativeList;
  private deleteApi = environment.url + environment.initiativeDelete;
  /**
   * Constructor for the CorporateListComponent.
   * @param makeapi The API service provider.
   * @param getdata The Value service provider.
   * @param notify The Notification service provider.
   * @param dialog The Material dialog service provider.
   * @param apiService The API service provider (redundant, but required).
   * @param notifyService The Notification service provider (redundant, but required).
   */
  constructor(
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    /**
     * Initializes the MatTableDataSource with empty data.
     */
    this.dataSource = new MatTableDataSource();
  }

  roleValue;

  /**
   * Angular lifecycle hook that is called after the component has been initialized.
   * Sets up initial states and fetches the initial list data.
   */
  ngOnInit(): void {
    // Set the visibility source to true
    this.getdata.isVisibleSource.next(true);
    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');
    // Fetch the initial list data from the API
    this.getListData();
  }
  /**
   * Fetches the list of initiatives from the API and updates the component data.
   * Used as an entry point when the component is initialized.
   */
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 25;
  pageNumber: number = 1;
  noData = true;
  getListData(): void {
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };
    this.ListApi();
  }

  /**
   * Fetches the list of initiatives from the API based on the pagination.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API
   */
  ListApi() {
    this.getdata.amizhthLoader('show');
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        // Handle the API response
        // If the count is 0, show the 'no data' message
        if (data.count == 0) {
          this.noData = true;
        } else {
          // Set the paginator data
          this.noData = false;
          this.pageTotalCount = data.count;
          this.disList = data.responsemodelList;

          // Set the MatTableDataSource with the new data
          this.dataSource = new MatTableDataSource(data.responsemodelList);
        }
      });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Handles the pagination events.
   * Updates the component data based on the current page index and page size.
   * @param event - The pagination event containing the page index and page size.
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };
    // Call the API to fetch the updated data
    this.ListApi();
  }
  /**
   * Opens a dialog to add a new initiative.
   * @param value - The title or value to be passed to the dialog.
   */
  initiveAddBtn(value) {
    // Open the CorporateAddComponent dialog with the provided data, preventing closure unless explicitly closed
    const dialogRef = this.dialog.open(CorporateAddComponent, {
      data: { title: value },
      disableClose: true,
      hasBackdrop: true,
    });

    // Subscribe to the observable that emits when the dialog is closed
    dialogRef.afterClosed().subscribe((result) => {
      // Refresh the list of corporate initiatives
      this.getListData();
      // Handle dialog close result here if needed
    });
  }
  /**
   * Opens a dialog to edit an existing initiative.
   * @param value - The title or value to be passed to the dialog.
   * @param id - The ID of the initiative to be edited.
   */
  editInitiatives(value, id) {
    // Open the CorporateAddComponent dialog with the provided data, preventing closure unless explicitly closed
    const dialogRef = this.dialog.open(CorporateAddComponent, {
      data: { title: value, _id: id },
      disableClose: true,
      hasBackdrop: true,
    });

    // Subscribe to the observable that emits when the dialog is closed
    dialogRef.afterClosed().subscribe((result) => {
      // Refresh the list of corporate initiatives
      this.getListData();
    });
  }
  /**
   * Deletes an initiative from the database
   * @param id - The ID of the initiative to be deleted
   */
  deleteInitiatives(id: string) {
    // Calls the delete API with the initiative ID and an empty body
    this.makeapi.method(this.deleteApi + id, '', 'delete').subscribe((data) => {
      // If the response status is Success, displays a success notification and calls the corporateList() method to update the list
      if (data.responseStatus == 'Success') {
        this.notify.notifysuccess(data.responseMessage);
        this.getListData();
      }
      // If the response status is not Success, displays an error notification with the response message
      else {
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
  /**
   * Redirects to the incubatee event page
   * @param id - The ID of the incubatee event
   */
  incubateeEvent(id: string): void {
    // Redirect to the incubatee event page by calling the eventId method and passing the base64 encoded ID
    this.getdata.eventId(btoa(id));
  }
}
